import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '../../../../../../../../../../@fuse/services/translation-loader.service';
import {
  CompanyImport,
  CompanyImportResponse,
  JobStatus,
} from '../../../../../../../../../core/model/company-import-text.model';
import { CompanyImportType, CompanyType } from '../../../../../../../../../core/model/company.model';
import { locale as english } from '../../../../../../seller/children/client/component/client-dialog/i18n/en';
import { locale as italian } from '../../../../../../seller/children/client/component/client-dialog/i18n/it';

@Component({
  selector: 'app-massive-company-import-view',
  templateUrl: './massive-company-import-view.component.html',
  styleUrls: ['./massive-company-import-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MassiveCompanyImportViewComponent implements OnChanges {

  @Input() jobStatus!: CompanyImportResponse;

  JobStatus = JobStatus;

  displayedColumns: string[] = [
    'businessName',
    'taxCode',
    'foundOnCribis',
    'existing',
    'existingByRole',
  ];

  mainCompany = new MatTableDataSource<CompanyImport>();
  relatedCompanies = new MatTableDataSource<CompanyImport>();
  hasMainCompany = false;

  isMainCompanySeller = false;

  constructor(
    private translateService: TranslateService,
    private _translationLoader: FuseTranslationLoaderService,
  ) {
    _translationLoader.loadTranslations(italian, english);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobStatus && changes.jobStatus.currentValue.status === JobStatus.COMPLETED) {

      const importType = this.jobStatus.parameters.mainCompanyImportType;
      if (importType === CompanyImportType.debtor_seller || importType === CompanyImportType.seller_debtor) {
        this.displayedColumns.push('existingRelationship');
      }

      this.hasMainCompany = this.jobStatus.output.mainCompany !== undefined;
      if (this.hasMainCompany) {
        this.isMainCompanySeller = this.jobStatus.output.mainCompany.companyType === CompanyType.seller;
        this.mainCompany.data = [this.jobStatus.output.mainCompany];
      }

      if (this.jobStatus.output.relatedCompanies) {
        this.relatedCompanies.data = this.jobStatus.output.relatedCompanies;
      }
    }
  }

  getRelatedCompaniesTableTitle(): string {
    if (this.hasMainCompany) {
      const key: string = this.isMainCompanySeller ? 'MASSIVE_COMPANY_DIALOG.CUSTOMERS' : 'MASSIVE_COMPANY_DIALOG.SUPPLIERS';
      return this.translateService.instant(key);
    }

    const key: string = this.jobStatus.parameters.mainCompanyImportType === CompanyImportType.seller ?
      'MASSIVE_COMPANY_DIALOG.COMPANY_IMPORT_TYPE_SELLER' : 'MASSIVE_COMPANY_DIALOG.COMPANY_IMPORT_TYPE_DEBTOR';
    return this.translateService.instant(key);
  }
}
